export default __webpack_public_path__ + "assets/images/icon-edit.50f9d094b38dc995babd0f0cb09b856e.svg";